import React, { FC, useMemo } from 'react';

import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import CouponFilter from '../components/coupon-filter/coupon-filter';
import CouponList from '../components/coupon-list/coupon-list';

const getFilteredCouponByCategories = (
  selectedCategory: number | null,
  listGroup: any,
  list: any,
) => {
  let currentList: any = listGroup;

  if (!selectedCategory) {
    return listGroup;
  }
  currentList = list;

  return currentList.filter((item: any) =>
    item.shopCategories.some(
      (category: any) => category.id === selectedCategory,
    ),
  );
};

const Home: FC = () => {
  const { groupCoupons, couponList, currentShopCategory, isError } =
    useSelector((state: RootState) => state.couponsAndCategoriesList);

  const filteredCouponsByCategories = useMemo(() => {
    if (groupCoupons.length) {
      return getFilteredCouponByCategories(
        Number(currentShopCategory),
        groupCoupons,
        couponList,
      );
    }
    return [];
  }, [currentShopCategory, groupCoupons]);

  return (
    <>
      <Helmet title="ПодароЧек — скидки, акции и подарки">
        <meta
          name="keywords"
          content="Скидки, Скидка, Кэшбэк, Карта, бесплатно, дней, 500, 5000, подарок, Доставка, Подарок, урока"
        />
        <meta
          name="description"
          content="Промокоды, скидки и акции. Экономьте на покупках в магазинах, супермаркетах и онлайн-сервисах. На сайте и в мобильном приложении."
        />
      </Helmet>
      {Boolean(isError) && <>Ошибка загрузки...</>}
      <CouponFilter />
      <CouponList
        isBanner
        cardsGet4Click={filteredCouponsByCategories}
      />
    </>
  );
};

export default Home;
